exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._8edom3nF{align-items:center;display:flex;justify-content:space-between;padding:2em 1.5em}._8edom3nF .VcvYj75P{font-size:15px}._8edom3nF>button{font-size:14px;font-weight:400}._8edom3nF:not(:first-child){border-top:1px solid #EAEAEA}", ""]);

// Exports
exports.locals = {
	"linkRow": "_8edom3nF",
	"heading": "VcvYj75P"
};